import React from 'react';
import styled from 'styled-components';
import { HamburgerIcon } from '../atoms/icons/HamburgerIcon';
import { Logo } from '../atoms/Logo';

interface MobileHeaderProps {
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
    isSidebarOpen,
    onToggleSidebar,
}) => {
    return (
        <StyledMobileHeader>
            <StyledLeftSection>
                <HamburgerIcon isOpen={isSidebarOpen} onClick={onToggleSidebar} />
            </StyledLeftSection>
            <StyledCenterSection>
                <Logo width={150} height={40} />
            </StyledCenterSection>
            <StyledRightSection />
        </StyledMobileHeader>
    );
};

const StyledMobileHeader = styled.div`
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 999;
  height: 70px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

const StyledLeftSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const StyledCenterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const StyledRightSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
`;
